import styled from 'styled-components';
import { SvgIcon } from '@insly/qmt-reactjs-ui-lib';

export const AddPolicyNumberWrapper = styled.div`
    position: relative;
`;

export const AddPolicyDialog = styled.div<{ isOpen: boolean }>`
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    gap: 16px;
    position: absolute;
    margin-top: 4px;
    background: ${({ theme }) => theme.colors.white};
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 16px;
    z-index: 1;
    min-width: 360px;
    
    .qmt-ui-input {
        height: auto;
    }
`;

export const AddPolicyDialogTitle = styled.h4``;

export const AddPolicyDialogControlsButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
`;

export const IconAdd = styled(SvgIcon)`
    width: 16px;
    height: 16px;
    margin-right: 4px;
`;
